import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { api, apiError } from "@/lib/api";

export default function BalanceCheckSettings() {
  const [s, setS] = useState(null);
  const [users, setUsers] = useState([]);
  useEffect(() => {
    api.get("/balance-check/settings").then(({ data }) => setS(data));
    api.get("/users").then(({ data }) => setUsers((data.items || data).filter((u) => u.is_active !== false))).catch(() => {});
  }, []);
  if (!s) return <div className="h-24 animate-pulse" />;
  const toggle = (id) => setS({ ...s, recipients: s.recipients.includes(id) ? s.recipients.filter((x) => x !== id) : [...s.recipients, id] });
  const save = async () => {
    try { setS((await api.put("/balance-check/settings", s)).data); toast.success("Hatırlatma ayarları kaydedildi"); } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="panel p-4 space-y-4 max-w-2xl" data-testid="balance-check-settings">
      <div className="text-sm text-slate-600">Ayın seçilen gününde alıcılara (uygulama içi + push) "Aylık bakiye kontrolü" bildirimi gönderilir; ayda bir kez, kontrol yapıldıysa gönderilmez.</div>
      <label className="flex items-center gap-2 text-sm"><Switch checked={s.enabled} onCheckedChange={(v) => setS({ ...s, enabled: v })} data-testid="balance-check-enabled" />Hatırlatma açık</label>
      <label className="flex items-center gap-2 text-sm">Ayın günü
        <input type="number" min={1} max={31} value={s.day} onChange={(e) => setS({ ...s, day: Number(e.target.value) || 1 })} className="h-8 w-20 rounded border px-2" data-testid="balance-check-day" />
      </label>
      <div>
        <div className="text-sm font-medium mb-1">Alıcılar <span className="text-xs text-slate-500">(boş = Süper Yönetici + Finans düzenleme yetkisi olanlar)</span></div>
        <div className="grid grid-cols-2 gap-1 max-h-56 overflow-auto border rounded p-2">
          {users.map((u) => (
            <label key={u.id} className="flex items-center gap-2 text-[13px]"><input type="checkbox" checked={s.recipients.includes(u.id)} onChange={() => toggle(u.id)} data-testid={`balance-check-recipient-${u.id}`} />{u.name}<span className="text-[11px] text-slate-400">{u.role_name}</span></label>
          ))}
        </div>
      </div>
      <Button onClick={save} data-testid="balance-check-settings-save">Kaydet</Button>
    </div>
  );
}
